module.exports = __webpack_public_path__ + "img/1080_15.ad65ae54.jpg";